module.exports = __webpack_public_path__ + "media/Manitou.comV4_small.8cf4e978.mp4";